<template>
  <div>
    <modalUpload @save="saveFile"> </modalUpload>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div class="col-md-16 px-3 py-3 mb-5">
          <div class="col d-column">
            <h1
              class="title pt-2 mb-0"
              v-text="$ml.get('progCreateTitle')"
            ></h1>
            <h1 class="title">
              <span v-text="$ml.get('progCreateSubTitle')" class="pb-2"></span>
            </h1>

            <div
              v-if="
                !['owner', 'administrator'].includes(
                  this.$store.getters['getUser'].role
                )
              "
              class="card mb-3"
            >
              <div class="card-header">Opss...</div>
              <div class="card-body">
                <div class="d-flex justify-content-center">
                  <h2 class="size-1_4 p-3">
                    Usuários do tipo visualizador não tem permissão para criar
                    programas!
                  </h2>
                </div>
              </div>
            </div>

            <font v-else>
              <div class="card mb-3">
                <div class="card-header" v-text="$ml.get('summary')">
                  Resumo
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="m-2 mr-4">
                      <span class="position-relative padding1">
                        <div class="avatar-wrapper mb-2" @click="showModal()">
                          <img class="profile-pic" :src="avatar" />
                          <input
                            class="file-upload"
                            type="file"
                            accept="image/*"
                          />
                        </div>
                        <a @click="showModal()" class="ico-edit camUpload">
                          <img
                            src="../../../../src/assets/icons/camera.svg"
                            class="ico-16 m-1"
                          />
                        </a>
                      </span>
                    </div>
                    <div class="col w-100 form-group mt-2">
                      <label v-text="$ml.get('title')">Título</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="name"
                        :placeholder="$ml.get('standoutCreate')"
                        maxlength="255"
                      />
                      <transition name="fade">
                        <label
                          v-if="validateError && !$v.name.required"
                          class="lblError"
                          v-text="$ml.get('theNameOfTheProgramMustBInformed')"
                          >O nome do programa deve ser informado</label
                        >
                        <label
                          v-if="validateError && !$v.name.regexOTN"
                          class="lblError"
                          v-text="$ml.get('cannotEnterSpecialCharacters')"
                          >Não é possível inserir caracteres especiais</label
                        >
                        <label
                          class="lblError"
                          v-if="validateError && !$v.name.minLength"
                          v-text="
                            $ml
                              .with('f', 6)
                              .with('l', 255)
                              .get('theProgramNameMustBeBetweenAndCharacters')
                          "
                          >O nome do programa deve ter entre 3 e 255
                          caracteres</label
                        >
                      </transition>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div>
                        <textarea
                          maxlength="2000"
                          class="form-control-textarea text-are-mark"
                          rows="5"
                          v-model="description"
                          :placeholder="$ml.get('dashCreatNdaAbriefsummary')"
                        >
                        </textarea>
                      </div>
                      <transition name="fade">
                        <label
                          v-if="validateError && !$v.description.required"
                          class="lblError"
                          v-text="
                            $ml.get('theDescriptionOfTheProgramMustBeInformed')
                          "
                          >A descrição do programa deve ser informado</label
                        >
                        <label
                          class="lblError"
                          v-if="validateError && !$v.description.minLength"
                          v-text="
                            $ml
                              .with('f', 3)
                              .with('l', 30)
                              .get(
                                'theProgramDescriptionMustBeBetweenAndCharacters'
                              )
                          "
                          >A descrição do programa deve ter entre 3 e 30
                          caracteres!</label
                        >
                      </transition>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="d-column flex-row">
                  <div
                    class="h-form h-profile-lg d-flex flex-column pb-3 align-items-center no"
                  >
                    <!-- Configurações -->
                    <config
                      @programByObjective="programByObjective"
                      number="1"
                      :dataBudget="dataBudget"
                      :typeProgram.sync="typeProgram"
                      :activeObjective.sync="activeObjective"
                      :ndaRequired.sync="ndaRequired"
                      :vpnRequired.sync="vpnRequired"
                      :hofActive.sync="hofActive"
                      :slug.sync="slug"
                      :errorPolicy.sync="errorPolicy"
                      :errorSlug="
                        validateError &&
                        (!$v.slug.required || !$v.slug.minLength)
                      "
                      :errorTypeProgram="
                        validateError && !$v.typeProgram.required
                      "
                      @verify-Plan="verifyPlan"
                      @set-Nda="setNda"
                      @set-Vpn="setVpn"
                      @set-Hof="setHof"
                      :budgetMessageError="budgetMessageError"
                    />
                    <!-- Objetivo do programa -->
                    <programByObjective
                      v-if="programByObjectiveActive"
                      @registeredPrograms="listOfProgramsByObjective"
                      number="2"
                      :htmlText="htmlText"
                      :errorPolicy.sync="errorPolicy"
                      :errorList.sync="errorList"
                    />
                    <!-- Política do programa -->
                    <policy
                      :number="programByObjectiveActive ? '3' : '2'"
                      :htmlText="htmlText"
                      :policy.sync="policy"
                      :errorPolicy="
                        validateError &&
                        (!$v.policy.minLength || !$v.policy.required)
                      "
                    />
                    <!-- Escopo -->
                    <scope
                      :number="programByObjectiveActive ? '4' : '3'"
                      :listScop="listScop"
                      :typeProgram="typeProgram.id"
                      :validateError="validateError"
                    />
                    <!--  Fora de Escopo -->
                    <!-- <outOfScope
                      :number="programByObjectiveActive ? '5' : '4'"
                      :listScop="listOutOfScope"
                      :typeProgram="typeProgram.id"
                      :validateError="validateError"
                    /> -->
                    <!-- Recompensas -->
                    <rewards
                      v-if="
                        typeProgram &&
                        typeProgram.id != 'vdp' &&
                        !programByObjectiveActive
                      "
                      number="4"
                      :bounty_severity="bounty_severity"
                      :optional_rewards="optional_rewards"
                    />

                    <!--  Usuários ativos -->
                    <userActives
                      :number="typeProgram.id === 'vdp' ? 4 : 5"
                      :selectedMembers="selectedMembers"
                    />
                    <!-- Concluir -->
                    <div class="d-flex align-self-start">
                      <div
                        class="position-relative align-self-center d-flex align-items-center align-self-center"
                      >
                        <div
                          class="circle-number d-flex justify-content-center align-items-center"
                        >
                          <span>{{
                            typeProgram && typeProgram.id != "vdp" ? 6 : 5
                          }}</span>
                        </div>
                      </div>
                      <div class="pl-3 d-flex">
                        <div class="align-self-start">
                          <h2 class="size-1_4 m-0 pb-1">
                            <strong v-text="$ml.get('conclude')"
                              >Concluir</strong
                            >
                          </h2>
                          <p class="d-flex align-items-center">
                            <span
                              class="align-self-center"
                              v-text="$ml.get('haveYouRevised')"
                            >
                              Revisou seu programa? Então pronto!
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-4"></span>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center">
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-pending"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span class="pb-5"></span></div>
                      </div>
                      
                      <div class="pl-3 d-flex w-100 align-items-center">
                        <div>
                        <div class="d-flex justify-content-center mb-2">
                           <RecaptchaV2 ref="recaptcha" @verify="setRecaptchToken" @expired="tokenRecaptcha = ''" />
                        </div>
                          <button
                            @click="validateForm()"
                            :disabled="!tokenRecaptcha"
                            class="btn"
                            v-text="$ml.get('submitForReview')"
                            >Enviar para Análise</button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </font>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import ProgramService from "../../../services/program.service";
// import PlanService from "../../../services/plan.service";
import $ from "jquery";
import Swal from "sweetalert2";
import { minLength, required } from "vuelidate/lib/validators";
import Config from "../../../components/company/program/config.vue";
// import OutOfScope from "../../../components/company/program/out_of_scope.vue";
import Policy from "../../../components/company/program/policy.vue";
import programByObjective from "../../../components/company/program/programByObjective.vue";
import Rewards from "../../../components/company/program/rewards.vue";
import Scope from "../../../components/company/program/scope.vue";
import userActives from "../../../components/company/program/userActives.vue";
import modalUpload from "../../../components/modalUpload.vue";
import { utils } from "../../../utils";
import RecaptchaV2 from "../../../components/recaptchaV2.vue";

const regexOTN = utils.regexCheck("OTN");

export default {
  components: {
    modalUpload,
    Config,
    Scope,
    // OutOfScope,
    Rewards,
    Policy,
    userActives,
    programByObjective,
    RecaptchaV2
  },
  data() {
    return {
      errorPolicy: "",
      errorProgram: false,
      errorList: "",
      listsProgramsBySelectedObjectives: [],
      programByObjectiveActive: false,
      loading: false,
      validateError: false,
      avatar: require("../../../assets/images/empty.png"),
      file: null,
      user: null,
      input: ``,
      name: "",
      description: "",
      slug: "",
      typeProgram: { id: "public", name: "public" },
      ndaRequired: { id: "no", name: "no" },
      vpnRequired: { id: "no", name: "no" },
      hofActive: { id: "no", name: "no" },
      policy: "",
      htmlText: "",
      activeObjective: false,

      listScop: [],
      listOutOfScope: [],

      txtOtherRewards: null,
      bounty_severity: [],
      optional_rewards: [],
      selectedManagers: [],
      currenry: "",
      budgetRegistration: null,
      budgetMessageError: {
        budgetValue: "",
        notification: "",
        breakPercentage: "",
      },
      tokenRecaptcha: "",
    };
  },

  validations: {
    name: { required, regexOTN, minLength: minLength(6) },
    description: { required, minLength: minLength(3) },
    slug: { minLength: minLength(2) },
    typeProgram: { required },
    policy: { required, minLength: minLength(3) },
    listScop: { required },
  },

  mounted() {
    this.user = this.$store.getters["getUser"];
    this.policy = `Seja bem-vindo(a) ao nosso programa de Bug Bounty. Caso identifique uma vulnerabilidade em algum dos sistemas abrangidos por este programa, encorajamos o envio responsável do relatório. Nosso time está preparado para analisá-lo e responder com agilidade.

---


##### Política de divulgação
* Não permitimos a divulgação das vulnerabilidades encontradas, exceto se não houver associação ou vínculo com o nome da empresa, nossos domínios, ou informações que nos identifiquem, sob pena de ações cabíveis;
* É expressamente proibida violações da privacidade, exposição de informações sensíveis, acesso ou exposição à quaisquer informação de clientes, destruição de dados e interrupção ou degradação do nosso serviço. Interaja apenas com contas que você registrou;
* Não discuta este programa ou quaisquer vulnerabilidades (mesmo as resolvidas) fora do programa sem o consentimento expresso da organização;
* É proibido condicionar o envio, a complementação ou a não divulgação de um relatório ao pagamento de valores fora das regras do programa. Qualquer tentativa de pressão ou ameaça de divulgação para obter recompensa será tratada como violação grave desta política.

---


##### Escopo
* Somente os ativos explicitamente listados no escopo oficial deste programa são autorizados para testes e elegíveis para recompensa;
* Relatórios sobre ativos fora do escopo serão fechados como fora de escopo, sem pontuação, recompensa ou agradecimento público, independentemente da severidade da vulnerabilidade reportada;
* Subdomínios, aplicações, APIs ou serviços que não estejam expressamente listados no escopo são considerados fora de escopo, mesmo que pertençam à empresa ou estejam relacionados aos ativos listados;
* Testes contra ativos fora do escopo não estão autorizados por esta política e podem caracterizar acesso não autorizado, sem o respaldo legal previsto neste programa;
* A definição de escopo válida é sempre a publicada na página oficial do programa na plataforma BugHunt.

---


##### Política Geral
* Faça um esforço de boa fé para evitar violações da privacidade, destruição de dados e interrupção ou degradação do nosso serviço. Interaja apenas com contas que você possui ou com permissão explícita do titular da conta.
* Caso você acesse acidentalmente dados de terceiros durante os testes, interrompa imediatamente a atividade, não armazene, não copie e não compartilhe esses dados, e informe o ocorrido no próprio relatório.
* Múltiplas vulnerabilidades que compartilham a mesma causa raiz técnica serão consideradas como um único relatório, com recompensa consolidada.
* Vulnerabilidades descobertas através de credenciais/informações vazadas, (exemplo: em fontes públicas, como Trello, GitHub, Wayback, Intelx, Foruns etc.), não são elegíveis para recompensas.
* Vulnerabilidades em sistemas fora do escopo não serão aceitas, nem consideradas para pontuação ou agradecimentos públicos.
* Os pesquisadores não estão autorizados a realizar quaisquer ações além da descoberta inicial e relato, incluindo tentar acessar ou manipular quaisquer contas ou dados associados às credenciais relatadas.
* Relatórios que descrevem vulnerabilidades do mesmo tipo e que ocorram em um mesmo endpoint ou funcionalidade serão considerados duplicados. Nesse caso, apenas o primeiro relatório válido será elegível para recompensa ou pontuação.
* Relatórios de vulnerabilidades que já foram identificadas e registradas internamente pelo nosso time, mesmo que ainda não tenham sido corrigidas publicamente, também serão considerados duplicados e não serão elegíveis para recompensa.
* Testes em ambientes de homologação, QA, staging ou pré-produção só serão aceitos se esses ambientes estiverem listados no escopo oficial.
* Para ser elegível à participação no programa, o pesquisador não deve ser nosso funcionário ou prestador de serviços, nem estar vinculado por contrato ativo conosco durante a realização dos testes.
* A recompensa poderá ser negada se houver motivos para acreditar que houve uma violação desta Política.
* Entrar em contato com nossa equipe sobre o status de um relatório por meio de qualquer outro canal que não seja a BugHunt resultará em desqualificação imediata para uma recompensa por esse relatório, e possível suspensão de nossos programas.
* Todos os contatos e comunicações devem ser feitos apenas pela plataforma da BugHunt, visando garantir segurança, transparência e rastreabilidade nas interações relacionadas aos relatórios.
* Quando solicitado pelo programa, identifique seus testes utilizando conta ou header identificador (ex: e-mail com sufixo indicado pelo programa ou header HTTP específico), facilitando a distinção entre atividade de pesquisa e ataque real.

---


##### Qualidade dos Relatórios
Para garantir uma triagem eficiente e justa para todos os pesquisadores, todo relatório enviado deve atender aos requisitos mínimos abaixo:

* Conter descrição técnica clara da vulnerabilidade, incluindo o ativo afetado, o endpoint ou funcionalidade envolvida e a causa raiz;
* Conter passos de reprodução completos e verificáveis, que permitam ao nosso time reproduzir o problema no ambiente real;
* Conter Prova de Conceito (PoC) funcional, com evidências reais obtidas no alvo (requisições e respostas completas, capturas de tela, vídeos ou payloads utilizados);
* Demonstrar impacto real de segurança. Relatórios puramente teóricos, sem demonstração prática, não serão aceitos;
* Relatórios incompletos poderão receber uma única solicitação de informações adicionais. Caso o pesquisador não complemente o relatório com as informações solicitadas dentro do prazo definido pela triagem, o relatório será fechado como inválido.

---


##### Uso de Inteligência Artificial e Ferramentas Automatizadas
O uso de ferramentas de Inteligência Artificial e automação como apoio à pesquisa é permitido. No entanto, o pesquisador é integral e pessoalmente responsável por todo o conteúdo enviado. Sendo assim:

* Todo relatório deve ser validado manualmente pelo pesquisador antes do envio. Relatórios baseados exclusivamente em saídas de ferramentas de IA, scanners ou analisadores automáticos, sem validação manual e sem PoC funcional, serão fechados como falso positivo ou spam;
* Relatórios contendo "alucinações" de IA, como endpoints, parâmetros, payloads ou comportamentos que não existem na aplicação real, evidências inconsistentes ou passos de reprodução genéricos que não correspondem ao alvo, serão classificados como spam;
* As respostas do pesquisador durante a triagem devem conter argumentação técnica própria e, quando aplicável, evidências novas e verificáveis. Respostas geradas por IA que apenas reformulam o relatório original, sem apresentar PoC válida ou evidência técnica adicional, não serão consideradas para reavaliação e poderão resultar no encerramento da discussão do relatório;
* A contestação de status ou severidade (CVSS) é limitada a uma contestação por relatório, e deve obrigatoriamente ser acompanhada de justificativa técnica fundamentada e evidência verificável. Contestações repetitivas ou automatizadas serão desconsideradas;
* O envio em massa de relatórios de baixa qualidade ou não validados (prática conhecida como "spray and pray") será tratado como abuso da plataforma;
* Nosso time se reserva o direito de solicitar, a qualquer momento, demonstração ao vivo ou evidência adicional da vulnerabilidade reportada. A recusa ou incapacidade de demonstrar o problema poderá resultar no fechamento do relatório como inválido.

---


##### Penalidades por Abuso
O descumprimento das regras de qualidade e conduta acima está sujeito à seguinte escala de penalidades:

* **Primeira ocorrência:** fechamento do relatório como spam, com a consequente perda de pontuação prevista pelas regras da plataforma BugHunt, além de advertência formal ao pesquisador;
* **Reincidência:** suspensão temporária da participação em nossos programas;
* **Casos graves ou reiterados:** banimento permanente de nossos programas, sem elegibilidade a recompensas pendentes relacionadas às violações, e reporte formal à plataforma BugHunt para as medidas cabíveis.

Relatórios fechados como spam ou falso positivo por descumprimento destas regras não geram pontuação, agradecimento público ou recompensa.

---


##### Sobre Referência a Domínios de Terceiros
Reconhecemos que, em alguns casos, pode haver menções ou links para domínios de terceiros em sites, redes sociais ou outras plataformas públicas. No entanto:

* Domínios de terceiros que não estejam sob controle direto ou propriedade da empresa não fazem parte do escopo do programa de segurança.

**Isso inclui domínios:**
* Citados como exemplos;
* Referenciados em postagens, releases ou documentos;
* Pertencentes a parceiros, fornecedores ou serviços externos;
* Utilizados como redirecionamentos externos ou para rastreamento, mas não mantidos por nós.

**Importante:** A exploração ou tentativa de takeover (sequestro) de domínios que não estejam sob titularidade direta da organização não será considerada válida para recompensa, mesmo que esses domínios sejam mencionados em páginas ou materiais da empresa.


---


##### Exclusões
Ao pesquisar, gostaríamos de pedir que você se abstenha de:
* Clickjacking em páginas sem informações sensíveis;
* Self-xss;
* Enumeração de nome de usuário/e-mail por meio da página de login ou através de mensagens de erro na página de "Esqueceu a senha";
* CSRF não autenticado /logout/login;
* CSRF em ações não críticas;
* Falta de cabeçalhos ou flags de segurança sem exploração efetiva (ex: CSP, HSTS, X-Frame-Options, X-Content-Type-Options, HttpOnly, SameSite, Secure);
* Content spoofing ou text injection sem vetor explorável ou sem poder alterar o HTML/CSS;
* Vulnerabilidades do lado do cliente baseadas em Flash, como Flash XSS;
* Redirecionamento aberto do Flash ou Injeção de conteúdo do Flash;
* Vulnerabilidades identificadas anteriormente;
* Ataques que exigem acesso físico ou MITM (Man in the middle);
* Bibliotecas com versões vulneráveis conhecidas sem uma PoC funcionando (ex. jQuery Libraries);
* CSV injection attack sem demonstrar uma PoC;
* Melhores práticas de configurações em SSL/TLS sem impacto explorável;
* Problemas de configuração de CORS sem impacto explorável;
* Ataques de brute-force em formulários de autenticação;
* Páginas de erros de stack trace (401/403/500) sem uma comprovação de vulnerabilidade;
* Método HTTP OPTIONS habilitado sem exploração efetiva;
* Qualquer atividade que possa levar à interrupção do nosso serviço (ex. DoS, DDoS);
* Aplicativos, scripts e integrações não oficiais de terceiros;
* Engenharia social (incluindo phishing) na nossa equipe ou terceiros;
* Registros SPF (Sender Policy Framework), DKIM ou DMARC inválidos ou ausentes;
* Quaisquer tentativas físicas contra nossas propriedades ou data centers;
* Informações de divulgação insensíveis (ex: versão do software);
* Disclosure de informações com baixo risco;
* Cross-site scripting em navegadores obsoletos ou acessível apenas à própria conta;
* Relatórios de scanners automatizados de vulnerabilidades que não são validados (ou seja, falsos positivos);
* Relatórios gerados por ferramentas de Inteligência Artificial sem validação manual e sem PoC funcional;
* Relatórios contendo endpoints, parâmetros, payloads ou comportamentos inexistentes na aplicação real (alucinações de IA);
* Problemas de captura de banner (como encontrar informações como o nome do servidor da web etc.);
* Complexidade da senha;
* Não possui confirmação de e-mail;
* Spamming;
* Negação de serviço;
* Tabnabbing;
* Falta de rate limiting;
* Uso de ferramentas automatizadas que podem gerar tráfego significativo e possivelmente prejudicar o funcionamento da aplicação, sem PoC válida;
* Subresource Integrity (SRI) não implementada;
* Cabeçalho HSTS ausente;
* Ataques que dependem exclusivamente de manipulação de rede local (ex: proxies, DNS spoofing);
* Ataques que exijam dispositivos com root ou jailbreak;
* Validações de formulário apenas no client-side, sem falha correspondente no backend;
* Autocomplete habilitado em formulários, sem impacto de segurança comprovado;
* Vulnerabilidades em ferramentas ou serviços de terceiros não mantidos pela empresa (ex: Typeform, Zendesk etc.);
* Falta de validação ou sanitização em campos irrelevantes, sem impacto direto ou uso posterior inseguro;
* Diretórios ou páginas padrão de servidor expostos (ex: phpinfo) sem dados sensíveis ou sem vetor explorável;
* Uso de métodos HTTP alternativos (PUT, DELETE) sem impacto ou bypass de autenticação;
* Mensagens JSON ou de erro estruturadas, mas sem dados sensíveis ou vetores de ataque;
* Relatórios baseados apenas em análise teórica ou estática, sem PoC funcional ou demonstração de impacto;
* Bugs divulgados publicamente em software de internet no prazo de 7 dias após sua divulgação;

---


##### Respaldo legal
Quaisquer atividades conduzidas de maneira consistente com esta política serão consideradas conduta autorizada e não iniciaremos uma ação legal contra você. Se uma ação legal for iniciada por terceiros contra você em relação às atividades conduzidas sob esta política, tomaremos medidas para tornar claro que suas ações foram conduzidas em conformidade com esta política.

Obrigado por ajudar a manter nossos sistemas e usuários em segurança!
`;

    if (this.$route.fullPath.split("?")[1]) {
      let type = this.$route.fullPath.split("?")[1];
      if (type == "vdp") {
        this.typeProgram = { id: "vdp", name: "VDP" };
      } else if (type == "public") {
        this.typeProgram = { id: "public", name: "public" };
      } else if (type == "private") {
        this.typeProgram = { id: "private", name: "private" };
      } else if (type == "target") {
        this.activeObjective = true;
      }
    } else {
      this.typeProgram = { id: "public", name: "public" };
    }

    $("html, body").animate({ scrollTop: 0 }, "5000");
  },
  watch: {
    listsProgramsBySelectedObjective() {
      this.errorPolicy = "";
    },
    budgetRegistration: {
      handler() {
        const { budgetValue, notification, pauseProgram } =
          this.budgetRegistration;
        if (budgetValue && this.budgetMessageError.budgetValue)
          return (this.budgetMessageError.budgetValue = false);
        if (notification && this.budgetMessageError.notification)
          return (this.budgetMessageError.notification = false);
        if (pauseProgram && this.budgetMessageError.breakPercentage)
          return (this.budgetMessageError.breakPercentage = false);
      },
      deep: true,
    },
  },
  methods: {
    setRecaptchToken(token) {
      this.tokenRecaptcha = token
    },

    listOfProgramsByObjective(data) {
      const filteredData = data?.registeredPrograms.map(
        ({ currency, ...rest }) => ({
          ...rest,
          currency: currency.value?.toUpperCase(),
        })
      );
      this.listsProgramsBySelectedObjectives = filteredData;
      this.errorPolicy = "";
    },
    programByObjective(data) {
      this.programByObjectiveActive = data.programByObjective;
    },
    dataBudget(value) {
      this.budgetRegistration = value;
    },
    selectedMembers(data) {
      let filterManagersId = data?.map((it) => it?._id);
      this.selectedManagers = filterManagersId ?? [];
    },
    async setNda(ndaRequired) {
      this.ndaRequired = ndaRequired;
    },

    async setVpn(vpnRequired) {
      this.vpnRequired = vpnRequired;
    },

    async setHof(hofActive) {
      this.hofActive = hofActive;
    },

    async verifyPlan(typeProgram) {
      this.typeProgram = typeProgram;

      // Descomentar quando os planos forem implementados
      // var self = this;
      // let  typeMl = type != 'vdp' ? self.$ml.get(type) : 'vdp';

      // if(this.$store.getters['getUser'].plan){
      //   PlanService.getVerifyPlan(`program_${type}`).then(
      //     (response) => {
      //       if(response.data == 'limit_exceeded'){
      //         Swal.fire({
      //           icon: 'info',
      //           html: `<h3 class="mb-2">${self.$ml.with(typeMl).get('programsLimitReached')}<h3>
      //           <h5 class="mb-2">${self.$ml.get('toAddMorePrograms')} <a href="/account?plans">${self.$ml.get('here')}</a>
      //           </h5>`,
      //           showConfirmButton: false,
      //           timer: 10000,
      //           onClose: () => {
      //             self.$router.back();
      //           }
      //         });
      //       }
      //     },
      //     (error) => {
      //       console.dir(error)
      //     }
      //   );
      // }
    },

    showModal() {
      this.$bvModal.show("modal-upload-avatar");
      setTimeout(() => {
        $("#avatarEditorCanvas").click();
      }, 50);
    },

    saveFile(file) {
      this.file = file.file;
      this.avatar = file.src;
    },
    validateForm() {
      this.errorList = "";
      this.loading = true;
      var self = this;

      // stop here if form is invalid
      this.$v.$touch();
      if (
        this.$v.$invalid ||
        (!this.slug && this.typeProgram.id != "private")
      ) {
        if (
          this.programByObjectiveActive === true &&
          this.listsProgramsBySelectedObjectives.length === 0
        ) {
          this.errorPolicy = "error";
        }
        if (this.budgetRegistration?.activateBudget) {
          const { budgetValue, notification, pauseProgram, breakPercentage } =
            this.budgetRegistration;
          if (budgetValue < 0) return;
          if (notification < 0 || notification > 100 || isNaN(notification))
            return;
          if (
            breakPercentage < 0 ||
            breakPercentage > 100 ||
            isNaN(breakPercentage)
          )
            return;
          if (!budgetValue) {
            this.budgetMessageError.budgetValue = true;
          }
          if (!notification) {
            this.budgetMessageError.notification = true;
          }
          if (pauseProgram && !breakPercentage) {
            this.budgetMessageError.breakPercentage = true;
          }
        }
        this.validateError = true;
        this.loading = false;
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("fillInAllFieldHighlightedInRed"),
        });
        $("html, body").animate({ scrollTop: 0 }, "5000");
        return;
      }

      if (this.budgetRegistration?.activateBudget) {
        const { budgetValue, notification, pauseProgram, breakPercentage } =
          this.budgetRegistration;
        if (budgetValue < 0) return;
        if (notification < 0 || notification > 100 || isNaN(notification))
          return;
        if (
          breakPercentage < 0 ||
          breakPercentage > 100 ||
          isNaN(breakPercentage)
        )
          return;
        if (!budgetValue) {
          Swal.fire({
            icon: "info",
            title: "",
            text: self.$ml.get("fillInAllFieldHighlightedInRed"),
          });
          $("html, body").animate({ scrollTop: 0 }, "5000");
          this.budgetMessageError.budgetValue = true;
          return;
        }
        if (!notification) {
          Swal.fire({
            icon: "info",
            title: "",
            text: self.$ml.get("fillInAllFieldHighlightedInRed"),
          });
          $("html, body").animate({ scrollTop: 0 }, "5000");
          this.budgetMessageError.notification = true;
          return;
        }
        if (pauseProgram && !breakPercentage) {
          Swal.fire({
            icon: "info",
            title: "",
            text: self.$ml.get("fillInAllFieldHighlightedInRed"),
          });
          $("html, body").animate({ scrollTop: 0 }, "5000");
          this.budgetMessageError.breakPercentage = true;
          return;
        }
      }
      if (
        this.programByObjectiveActive === true &&
        this.listsProgramsBySelectedObjectives.length === 0
      ) {
        this.errorPolicy = "error";
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("fillInAllFieldHighlightedInRed"),
        });
        $("html, body").animate({ scrollTop: 0 }, "5000");

        this.loading = false;
        return;
      }

      this.validateError = false;
      this.saveProgram();
    },

    saveProgram() {
      var self = this;

      const formData = new FormData();
      formData.append("tokenRecaptcha", this.tokenRecaptcha);
      formData.append("file", this.file);
      formData.append("name", this.name);
      formData.append("description", this.description);
      formData.append("managers", JSON.stringify(this.selectedManagers));

      if (this.slug && this.typeProgram.id != "private") {
        formData.append("slug", this.slug);
      }

      formData.append("type", this.typeProgram?.id);
      formData.append("nda", String(this.ndaRequired?.id));
      formData.append("vpn_required", String(this.vpnRequired?.id));
      formData.append("policy", this.policy);
      formData.append("scope", JSON.stringify(this.listScop));
      // formData.append("out_of_scope", JSON.stringify(this.listOutOfScope));

      formData.append("bounty_low", this.bounty_severity.bounty_low);
      formData.append("bounty_medium", this.bounty_severity.bounty_medium);
      formData.append("bounty_high", this.bounty_severity.bounty_high);
      formData.append("bounty_critical", this.bounty_severity.bounty_critical);
      // formData.append("currency", this.currenry);
      formData.append(
        "ranking_type",
        this.hofActive?.id == "yes" ? "hall" : "standard"
      );

      if (this.programByObjectiveActive) {
        const target_settings = {
          active: true,
          targets: this.listsProgramsBySelectedObjectives.map((obj) => {
            delete obj.edit;
            return obj;
          }),
        };
        formData.append("target_settings", JSON.stringify(target_settings));
      }

      const budgetObj = {
        budget: {
          active: this.budgetRegistration?.activateBudget,
          max_value: this.budgetRegistration?.budgetValue,
          percentage_alert: this.budgetRegistration?.notification,
          pause_program: this.budgetRegistration?.pauseProgram,
          percentage_pause: this.budgetRegistration?.breakPercentage,
        },
      };
      if (this.budgetRegistration?.activateBudget) {
        formData.append("settings", JSON.stringify(budgetObj));
      }

      formData.append(
        "optional_rewards",
        JSON.stringify(this.optional_rewards)
      );

      ProgramService.postProgram(formData).then(
        () => {
          self.loading = false;
          Swal.fire({
            icon: "success",
            title: self.$ml.get("successfullyCreatedProgram"),
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.$router.push("/program");
          });

          this.programByObjectiveActive = false;
          
          self.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
        },
        (error) => {
          self.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";

          self.loading = false;
          const splitMessage = error.response.data.message.split("_");
          const errorType = splitMessage[1] + splitMessage[2] + splitMessage[3];

          const statusCode = error.response.data.statusCode;
          const errMessage = error.response.data.message;

          if (
            statusCode === 422 &&
            errMessage === "Informar no máximo 10 objetivos!"
          ) {
            this.errorList = "error";
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("unableToCompleteThisRequest"),
            });

            return;
          }

          if (errorType === "programlimitexceeded") {
            const programType = splitMessage[0];
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml
                .with(
                  "programType",
                  programType === "vdp" ? "VDP" : self.$ml.get(programType)
                )
                .get("typeProgramLimitExceeded"),
            });
          } else if (errorType === "scopelimitexceeded") {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("scopeLimitExceeded"),
            });
          } else if (
            error.response.data.message ==
            "Já existe um programa cadastrado com essa slug!"
          ) {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("thereIsAlreadyProgramSlug"),
            });
          } else if (
            error.response.data.message ==
            "Já existe um programa cadastrado com esse nome!"
          ) {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("thereIsAlreadyAprogram"),
            });
          } else {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("unableToCompleteThisRequest"),
            });
          }
        }
      );
    },
  },
};
</script>
<style>
.avatar-wrapper {
  height: 85px;
  width: 85px;
}

.editor-toolbar {
  border: 0px !important;
}

body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown),
html.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
  height: 100% !important;
  overflow-y: visible !important;
}
</style>
